module.exports = __webpack_public_path__ + "img/voucher-folyamatabra-0622.955a5354.jpg";